export default __webpack_public_path__ + "static/media/MDAutilIcon.419232aa.svg";